import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  createNewEducation,
  fetchEditEducation,
  fetchEducationList,
} from "../actions/education";
import {
  fetchClearEducationCategoryFormList,
  fetchEducationCategoryFormList,
} from "../actions/educationCategory";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Editor } from "ckeditor5-custom-build/build/ckeditor";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import InputField from "../components/Admin/Reusable/InputField";
import { LocalizationProvider } from "@mui/x-date-pickers";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { TimePicker } from "@mui/x-date-pickers";
import { basicFormValidationHandler } from "../utils";
import dayjs from "dayjs";
import { fetchCountryFormList } from "../actions/country";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import FormSystemInformation from "../components/Admin/Reusable/FormSystemInformation";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";

const UploadField = ({
  handleFileChange,
  placeholder,
  fieldName,
  className,
}) => {
  return (
    <div className={className}>
      <label>
        <input
          className="test-test"
          id={`file-input-${fieldName}`}
          name={fieldName}
          accept={".jpg, .mp4"}
          multiple={false}
          type="file"
          hidden
          onChange={handleFileChange}
        />
        <Button
          variant="contained"
          component="span"
          className="default-btn-primary"
          size="small"
          startIcon={<FileUploadRoundedIcon />}
        >
          {placeholder}
        </Button>
      </label>
    </div>
  );
};

const EducationAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  //breadcrumb
  const translateForm = "educationForm";
  const translateModule = "education";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const initialState = {
    name: "",
    educationCategoryId: "",
    countryId: "",
    points: "",
    duration: "",
    description: "",
    status: "ACTIVE",
    sector: 0,
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(null);
  const [categoryDisabled, setCategoryDisabled] = useState("");

  const { educationDetail } = useSelector((state) => state.educationReducer);

  const { countryFormList } = useSelector((state) => state.countryReducer);
  const { educationCategoryFormList } = useSelector(
    (state) => state.educationCategoryReducer
  );

  const handleInputChange = (e) => {
    if (e.target.name === "duration") {
      // Ako je name 'duration', formatiraj vrednost
      setData({
        ...data,
        [e.target.name]: dayjs(e.target.value).format("HH:mm:ss"), // Pretvori u format koji je potreban
      });
    } else {
      if (e.target.name === "countryId") {
        setCategoryDisabled(false);
        dispatch(fetchEducationCategoryFormList(e.target.value));
      }

      setData({ ...data, [e.target.name]: e.target.value });
    }
  };

  useEffect(() => {
    dispatch(fetchCountryFormList());
  }, [dispatch]);

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
      dispatch(fetchClearEducationCategoryFormList());
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchEducationList(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (educationDetail && id) {
      setData({
        ...data,
        name: educationDetail.name || "",
        description: educationDetail.description || "",
        image: educationDetail.image || "",
        video: educationDetail.video || "",
        points: educationDetail.points || "",
        duration: educationDetail.duration || "",
        countryId: educationDetail.countryId || "",
        educationCategoryId: educationDetail.educationCategoryId || "",
        status: educationDetail.status || "ACTIVE",
        createdAt: educationDetail.createdAt || "",
        updatedAt: educationDetail.updatedAt || "",
        sector: educationDetail.sector === "" ? 0 : educationDetail.sector || 0,
      });
      if (educationDetail && educationDetail.countryId) {
        setCategoryDisabled(false);
        dispatch(fetchEducationCategoryFormList(educationDetail.countryId));
      }
    }
  }, [educationDetail, id, dispatch]);

  useEffect(() => {
    if (countryFormList?.length == 1) {
      setData((prevData) => ({
        ...prevData,
        countryId: countryFormList[0].id,
      }));

      setCategoryDisabled(false);
      dispatch(fetchEducationCategoryFormList(countryFormList[0].id));
    }
  }, [countryFormList]);

  const clientValidationHandler = () => {
    const { name, points, duration, educationCategoryId, countryId } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      name,
      points,
      duration,
      educationCategoryId,
      countryId,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }

    const formData = new FormData();

    formData.append("sector", data.sector == 0 ? "" : data.sector);
    formData.append("image", image);
    formData.append("video", video);
    formData.append("name", data.name);
    formData.append("points", data.points);
    formData.append("duration", data.duration);
    formData.append("description", data.description);
    formData.append("countryId", data.countryId);
    formData.append("status", data.status);
    formData.append("educationCategoryId", data.educationCategoryId);

    if (id) {
      formData.append("id", id);
      dispatch(fetchEditEducation(formData, navigate));
    } else {
      if (!image) {
        toast.error("Morate odabrati sliku", { theme: "colored" });
        return;
      }

      if (!video) {
        toast.error("Morate odabrati video", { theme: "colored" });
        return;
      }
      dispatch(createNewEducation(formData, navigate));
    }
  };

  const handleFileDelete = (fieldName) => {
    switch (fieldName) {
      case "image":
        setImage(null);
      case "video":
        setVideo(null);
      default:
        break;
    }

    // Resetovanje input polja
    //TODO: Ispraviti da ide preko refa
    document.getElementById(`file-input-${fieldName}`).value = "";
  };

  const handleFileChange = (event) => {
    const name = event.target.name;
    const selectedFile = event.target.files[0];

    if (
      selectedFile &&
      (selectedFile.type === "image/jpeg" ||
        selectedFile.type === "image/png" ||
        selectedFile.type === "video/mp4")
    ) {
      switch (name) {
        case "image":
          setImage(selectedFile);
          break;
        case "video":
          setVideo(selectedFile);
          break;
        default:
          return;
      }
    }
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        extraTitle={educationDetail && educationDetail.name}
        pageType={pageType}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <Card>
                    <Card.Header>
                      <FormTitleMain />
                    </Card.Header>
                    <Card.Body>
                      <div className="education-holder-admin-left-side-text">
                        <Row>
                          <Col lg={6} md={12} xs={12} className="mb-4">
                            <InputField
                              label="Naziv edukacije"
                              name="name"
                              value={data.name}
                              onChange={handleInputChange}
                              error={errors}
                              errorsHandler={setErrors}
                              fullWidth
                              size="small"
                              required
                            />
                          </Col>
                          <Col lg={3} md={12} xs={12} className="mb-4">
                            <InputField
                              label="Poeni"
                              name="points"
                              value={data.points}
                              onChange={handleInputChange}
                              error={errors}
                              errorsHandler={setErrors}
                              fullWidth
                              size="small"
                              required
                            />
                          </Col>{" "}
                          <Col lg={3} md={12} xs={12} className="mb-4">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <TimePicker
                                label="Trajanje"
                                value={dayjs(data?.duration, "HH:mm:ss")}
                                name="duration"
                                onChange={(newValue) =>
                                  handleInputChange({
                                    target: {
                                      name: "duration",
                                      value: newValue,
                                    },
                                  })
                                }
                                inputFormat="HH:mm:ss"
                                renderInput={(params) => (
                                  <InputField
                                    {...params}
                                    size="small"
                                    required
                                    error={errors}
                                    errorsHandler={setErrors}
                                    fullWidth
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </Col>
                          <Col lg={4} md={12} xs={12} className="mb-4">
                            <FormControl
                              fullWidth
                              required
                              size="small"
                              error={errors?.countryId ? true : false}
                              disabled={countryFormList?.length == 1}
                            >
                              <InputLabel id="demo-simple-select-label">
                                Država
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.countryId}
                                label="Država"
                                name="countryId"
                                onChange={handleInputChange}
                                size="small"
                              >
                                {countryFormList?.map((item, key) => (
                                  <MenuItem value={item.id} key={key}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                              {errors?.countryId && (
                                <FormHelperText>obavezno polje</FormHelperText>
                              )}
                            </FormControl>
                          </Col>
                          <Col lg={4} md={12} xs={12} className="mb-4">
                            <FormControl
                              fullWidth
                              required
                              error={errors?.educationCategoryId ? true : false}
                            >
                              <InputLabel
                                id="demo-simple-select-label"
                                size="small"
                              >
                                Kategorija edukacije
                              </InputLabel>
                              <Select
                                value={data.educationCategoryId}
                                label="Kategorija edukacije"
                                name="educationCategoryId"
                                onChange={handleInputChange}
                                size="small"
                                disabled={
                                  categoryDisabled ||
                                  educationCategoryFormList.length === 0
                                }
                              >
                                {educationCategoryFormList?.map((item, key) => (
                                  <MenuItem value={item.id} key={key}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                              {errors?.educationCategoryId && (
                                <FormHelperText>obavezno polje</FormHelperText>
                              )}
                            </FormControl>
                          </Col>
                          <Col lg={4} md={12} xs={12} className="mb-4">
                            <FormControl
                              fullWidth
                              required
                              size="small"
                              error={errors?.sector ? true : false}
                              disabled={id || !data.countryId}
                            >
                              <InputLabel id="demo-simple-select-label">
                                {t("global.sectorName")}
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data?.sector}
                                label={t("global.sectorName")}
                                name="sector"
                                onChange={handleInputChange}
                                size="small"
                              >
                                <MenuItem value="0">
                                  {t("global.ALL_SECTORS")}
                                </MenuItem>
                                <MenuItem value={"DEVICE_FOR_HOUSE"}>
                                  {t("global.DEVICE_FOR_HOUSE")}
                                </MenuItem>
                                <MenuItem value={"TV_AUDIO"}>
                                  {t("global.TV_AUDIO")}
                                </MenuItem>
                                <MenuItem
                                  value={"DEVICE_FOR_HOUSE_AND_TV_AUDIO"}
                                >
                                  {t("global.DEVICE_FOR_HOUSE_AND_TV_AUDIO")}
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Col>
                          <Col lg={12} md={12} xs={12} className="mb-4">
                            <CKEditor
                              name="description"
                              editor={Editor}
                              data={data.description}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setData((prevUser) => ({
                                  ...prevUser,
                                  description: data,
                                }));
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <SelectStatus
                        data={data}
                        archiveType={true}
                        handleInputChange={handleInputChange}
                      />
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>Slika</Card.Header>
                        <Card.Body>
                          <UploadField
                            handleFileChange={handleFileChange}
                            placeholder={"Priložite sliku"}
                            fieldName={"image"}
                          />
                          {data.image && (
                            <Col lg={12} md={12} xs={12}>
                              <Fragment>
                                <div className="preview-image-holder-admin">
                                  <img
                                    src={data.image}
                                    alt={data.image?.name}
                                    width={`100%`}
                                  />
                                </div>
                              </Fragment>
                            </Col>
                          )}

                          {image && (
                            <Fragment>
                              <div className="mt-2">
                                Odabrana slika: <b>{image?.name}</b> (Veličina:{" "}
                                {(image?.size / 1048576).toFixed(2)} MB)
                              </div>
                              <div className="preview-image-holder-admin mt-2">
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt={image?.name}
                                  width={`100%`}
                                />
                              </div>
                              <div className="text-end mt-2">
                                <Button
                                  variant="contained"
                                  color="error"
                                  type="button"
                                  size="small"
                                  startIcon={<DeleteIcon />}
                                  onClick={() => handleFileDelete("image")}
                                >
                                  Obriši
                                </Button>
                              </div>
                            </Fragment>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>Video</Card.Header>
                        <Card.Body>
                          <UploadField
                            handleFileChange={handleFileChange}
                            placeholder={"Priložite video"}
                            fieldName={"video"}
                          />
                          {data.video && (
                            <Col lg={12} md={12} xs={12}>
                              <Fragment>
                                <div className="preview-image-holder-admin">
                                  <video
                                    controls
                                    width="100%"
                                    src={data.video}
                                  ></video>
                                </div>
                              </Fragment>
                            </Col>
                          )}

                          {video && (
                            <Fragment>
                              <div className="mt-2">
                                Odabrani video: <b>{video?.name}</b> (Veličina:{" "}
                                {(video?.size / 1048576).toFixed(2)} MB)
                              </div>
                              <div className="preview-video-holder-admin mt-2">
                                <video
                                  controls
                                  width="100%"
                                  src={URL.createObjectURL(video)}
                                >
                                  Vaš pregledač ne podržava HTML video.
                                </video>
                              </div>
                              <div className="text-end mt-2">
                                <Button
                                  variant="contained"
                                  color="error"
                                  type="button"
                                  size="small"
                                  startIcon={<DeleteIcon />}
                                  onClick={() => handleFileDelete("video")}
                                >
                                  Obriši
                                </Button>
                              </div>
                            </Fragment>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                    {id && (
                      <Col lg={12}>
                        <FormSystemInformation data={data} />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default EducationAdd;
